import { Injectable } from '@angular/core';

declare var gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsEventsService {

  constructor() { }

  public emitEvent(eventCategory: string,
    eventAction: string,
    eventLabel: string = '',
    eventValue: number = 0) {

      gtag('event', eventAction, {
        'event_category': eventCategory,
        'event_label': eventLabel,
        'value': eventValue
      });

  }

}
